import { render, staticRenderFns } from "./SuperVisaView.vue?vue&type=template&id=5113855a&scoped=true"
import script from "./SuperVisaView.vue?vue&type=script&lang=js"
export * from "./SuperVisaView.vue?vue&type=script&lang=js"
import style0 from "./SuperVisaView.vue?vue&type=style&index=0&id=5113855a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5113855a",
  null
  
)

export default component.exports